import { CustomApiException } from '@/modules/core/app/models/CustomApiException';

export class DomainSsoExistsException extends CustomApiException {
  constructor(model: Partial<DomainSsoExistsException> = {}) {
    super(model);
  }
}
